import script from "./BridgesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BridgesList.vue?vue&type=script&lang=ts&setup=true"

import "./BridgesList.vue?vue&type=style&index=0&id=368dd224&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-368dd224"]])

export default __exports__